<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="'1536px'"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" :rules="rules">
        <el-form-item label="点位选择">
          <el-cascader
            v-model="selected"
            style="width: 100%;"
            :options="treeData"
            :show-all-levels="false"
            filterable
            :props="{
              multiple: true,
              checkStrictly: true,
              children: 'childs',
              label: 'pointName',
              value: 'id'
            }"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <transferTable @selectedData="selectedData"></transferTable>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addBatchPointPersonFun"
        >确 定</el-button
      >
      <!-- <el-button v-if="activeSteps == 0" type="primary" @click="nextSteps"
        >下一步</el-button
      >
      <el-button v-if="activeSteps == 1" type="primary" @click="prevSteps"
        >上一步</el-button
      > -->
    </span>
  </el-dialog>
</template>
<script>
import transferTable from "@/components/transfer-table/index";
// import index from "../index";
import {
  getPointLevelListTree,
  getIIamUseroAll,
  addBatchPointPerson
} from "@/api/point.js";
export default {
  components: { transferTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  // mixins: [index],
  data() {
    return {
      // activeSteps: 0,
      title: "点位人员管理",
      options: [],
      formInline: {
        typeName: "",
        enableStatus: 0,
        id: ""
      },
      rules: {
        typeName: [
          { required: true, message: "请输入点位类型", trigger: "blur" }
        ],
        enableStatus: [
          { required: true, message: "请选择是否启用", trigger: "blur" }
        ]
      },
      options: [],
      treeData: [],
      selected: [],
      userList: [],
      selectedTableId: []
    };
  },
  mounted() {
    this.getPointLevelListTreeFun();
    // this.getIIamUseroAllFun();
  },
  methods: {
    // nextSteps() {
    //   this.activeSteps = 1;
    //   this.title = "第二步：人员选择";
    // },
    // prevSteps() {
    //   this.activeSteps = 0;
    //   this.title = "第一步：点位选择";
    // },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        typeName: this.formInline.typeName,
        enableStatus: this.formInline.enableStatus,
        id: this.formInline.id
      };
      let res = null;
      if (this.curItem.id) {
        res = await updatePointType(params);
      } else {
        res = await addPointType(params);
      }

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async getPointLevelListTreeFun() {
      const res = await getPointLevelListTree({
        id: "0"
      });
      this.treeData =
        res.data.data && res.data.data.length ? res.data.data[0].childs : [];
    },
    selectedData(data) {
      if (!data || !data.length) return;
      this.selectedTableId = data.map(item => item.id);
    },
    async addBatchPointPersonFun() {
      console.log(this.selected);
      console.log(this.selectedTableId);
      let pointIds = [];
      this.selected.forEach(item => {
        let len = item.length - 1;
        pointIds.push(item[len]);
      });
      console.log(pointIds);
      const res = await addBatchPointPerson({
        personIds: this.selectedTableId,
        pointIds: pointIds
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-step__head.is-success,
/deep/.el-step__head.is-process {
  .is-text {
    width: 28px;
    height: 28px;
    background: #0495ff;
    border: 1px solid #0495ff;
    .el-icon-check:before {
      color: #fff;
    }
    .el-step__icon-inner {
      color: #fff;
    }
  }
}
/deep/.el-step__title.is-success,
/deep/.el-step__title.is-process {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #0495ff;
}
/deep/.el-step__head.is-wait {
  .is-text {
    width: 28px;
    height: 28px;
    background: #e3f0f9;
    border: 1px solid #e3f0f9;
    .el-step__icon-inner {
      color: #9bb6c9;
    }
  }
}
/deep/.el-step__title.is-wait {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #86909c;
}
/deep/.el-step__line {
  background: none;
}
/deep/.el-step__line-inner {
  border-style: dashed !important;
  border-color: #dde6ec !important;
  width: 100% !important;
  border-width: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointPerson/components/addDialog.vue